<template>
  <form @submit.prevent="handleFormSubmit" class="form">
    <div>
      <register-title class="form__title">{{
        $t("register address")
      }}</register-title>
      <label for="citizenship" class="label">{{ $t("country") }}</label>
      <exp-select
        :options="registrationCountryList()"
        v-model="form.registration_country"
        :title="$t('choose country')"
      ></exp-select>
      <register-input
        v-model="form.registration_city"
        componentID="city"
        :label="$t('city')"
        :isRequired="true"
        inputType="text"
        :inputPlaceholder="$t('city')"
        class="form__input"
      />
      <register-input
        v-model="form.registration_street"
        componentID="street"
        :label="$t('street')"
        :isRequired="true"
        inputType="text"
        :inputPlaceholder="$t('address')"
        class="form__input"
      />
      <div class="row">
        <div class="col-xs-4">
          <register-input
            v-model="form.registration_house"
            componentID="registration_house"
            :label="$t('house')"
            :isRequired="true"
            inputType="text"
            :inputPlaceholder="$t('house')"
            class="form__input"
          />
        </div>
        <div class="col-xs-4">
          <register-input
            v-model="form.registration_block"
            componentID="registration_house"
            :label="$t('block')"
            :isRequired="false"
            inputType="text"
            :inputPlaceholder="$t('block')"
            class="form__input"
          />
        </div>
        <div class="col-xs-4">
          <register-input
            v-model="form.registration_apartment"
            componentID="registration_apartment"
            :label="$t('apartment')"
            :isRequired="false"
            inputType="text"
            :inputPlaceholder="$t('apartment')"
            class="form__input"
          />
        </div>
      </div>
      <register-input
        v-model="form.registration_index"
        componentID="registration_index"
        :label="$t('post index')"
        :isRequired="true"
        inputType="text"
        :inputPlaceholder="$t('post index')"
        class="form__input"
      />
    </div>
    <div>
      <input
        type="checkbox"
        :true-value="1"
        :false-value="0"
        class="form__checkbox"
        v-model="form.is_registered_actual"
      />
      {{ $t("address of actual") }}
      {{ isUserLegal ? $t("location") : $t("residence") }}
      {{ $t("coincides with register address") }}
    </div>
    <div v-if="!form.is_registered_actual">
      <hr class="horizontal-line" />
      <register-title
        class="form__title"
        style="text-align: left; font-size: 20px;"
      >
        {{ isUserLegal ? $t("actual address") : $t("register actual address") }}
      </register-title>
      <register-input
        v-model="form.actual_city"
        componentID="actual_city"
        :label="$t('city')"
        :isRequired="true"
        inputType="text"
        :inputPlaceholder="$t('city')"
        class="form__input"
      />
      <register-input
        v-model="form.actual_street"
        componentID="actual_street"
        :label="$t('street')"
        :isRequired="true"
        inputType="text"
        :inputPlaceholder="$t('address')"
        class="form__input"
      />
      <div class="row">
        <div class="col-xs-4">
          <register-input
            v-model="form.actual_house"
            componentID="actual_house"
            :label="$t('house')"
            :isRequired="true"
            inputType="text"
            :inputPlaceholder="$t('house')"
            class="form__input"
          />
        </div>
        <div class="col-xs-4">
          <register-input
            v-model="form.actual_block"
            componentID="actual_block"
            :label="$t('block')"
            :isRequired="false"
            inputType="text"
            :inputPlaceholder="$t('block')"
            class="form__input"
          />
        </div>
        <div class="col-xs-4">
          <register-input
            v-model="form.actual_apartment"
            componentID="actual_apartment"
            :label="$t('apartment')"
            :isRequired="false"
            inputType="text"
            :inputPlaceholder="$t('apartment')"
            class="form__input"
          />
        </div>
      </div>
      <register-input
        v-model="form.actual_index"
        componentID="actual_index"
        :label="$t('post index')"
        :isRequired="true"
        inputType="text"
        :inputPlaceholder="$t('post index')"
        class="form__input"
      />
    </div>
    <button
      class="button filled form__button"
      @click="form.actual_address = form.registration_address"
    >
      {{ $t("confirm") }}
    </button>
  </form>
</template>

<script>
import RegFormMixin from "../form_mixin";
import { FhsAxios } from "../../../services/axios";

export default {
  props: ["user_profile"],
  data() {
    return {
      form: {
        is_registered_actual: 0,
        registration_country: null,
        // ----------------------------- reg address
        registration_city: null,
        registration_street: null,
        registration_house: null,
        registration_block: null,
        registration_apartment: null,
        registration_index: null,
        // ----------------------------- act address
        actual_city: null,
        actual_street: null,
        actual_house: null,
        actual_block: null,
        actual_apartment: null,
        actual_index: null
      }
    };
  },
  mixins: [RegFormMixin],
  watch: {
    user_profile: function(value) {
      this.fetchForm();
    }
  },
  methods: {
    isFormChanged() {
      return JSON.stringify(this.old_form) !== JSON.stringify(this.form);
    },
    fetchForm() {
      try {
        Object.entries(this.user_profile.userProfile).map(obj => {
          if (obj[0] in this.form) {
            this.form[obj[0]] = obj[1];
          }
        });
        this.old_form = JSON.parse(JSON.stringify(this.form));
      } catch (e) {
        // ERROR HANDLER
      }
    },
    nextStep() {
      if (this.isUserLegal) {
        this.$router.push({ name: "legal-tax-residency" });
      } else {
        this.$router.push({ name: "income-info" });
      }
    },
    saveData() {
      if (this.form.is_registered_actual) {
        this.form.actual_city = this.form.registration_city;
        this.form.actual_street = this.form.registration_street;
        this.form.actual_house = this.form.registration_house;
        this.form.actual_block = this.form.registration_block;
        this.form.actual_apartment = this.form.registration_apartment;
        this.form.actual_index = this.form.registration_index;
      }
      this.$emit("loading-status", true);
      let url = `user/profile`;
      FhsAxios.post(url, this.form).then(res => {
        if (res.data.status) {
          this.$toasted.success(this.$t("data saved"));
          this.$emit("loading-status", false);
          this.nextStep();
          return;
        }
        this.$toasted.error(this.$t("error"));
        this.$emit("loading-status", false);
      });
    },
    handleFormSubmit() {
      if (!this.isFormChanged()) {
        this.nextStep();
      } else {
        this.saveData();
      }
    }
  },
  beforeMount() {
    this.fetchForm();
  }
};
</script>

<style scoped>
.copy_address {
  padding: 5px 20px;
  background-color: rgba(0, 0, 0, 0.2);
  color: white;
  border-radius: 5px;
  border: none;
  font-size: 13px;
}
.form {
  color: #ffffff;
}

.form__title {
  margin-bottom: 20px;
}

.form__input {
  margin-bottom: 15px;
}

.form__checkbox {
  margin-right: 5px;
}

.form__button {
  width: 100%;
  margin-top: 30px;
  padding: 15px 0;
  font-size: 15px;
}
</style>
